import { Routes, Route } from "react-router-dom";

import AdminLayout from "../layout/AdminLayout";
import Login from "../pages/usuarios_admin/LoginAdmin";
import ProtectedRoute from "./ProtectedRoute";

function AdminHome() {
  return (
    <div style={{ padding: "8px 4px" }}>
      <h1 style={{ margin: 0, fontSize: "1.5rem" }}>Inicio</h1>
      <p style={{ opacity: 0.85, marginTop: "12px" }}>
        Selecciona una opción en el menú lateral.
      </p>
    </div>
  );
}

function AdminRoutes() {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute redirectTo="/administrator/admin/login" />
        }
      >
        <Route element={<AdminLayout />}>
          <Route index element={<AdminHome />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default AdminRoutes;
